import React from "react";
import "./nftCardBig.scss"
import { StaticImage } from "gatsby-plugin-image";

const NftCardBig = () => {
    return <div className="nft-big">
        <StaticImage
              src="../images/mm0.webp"
              loading="lazy"
              width={320}
              quality={95}
              formats={["auto", "webp", "avif"]}
              alt="Marine Mogul humpback"
              className="nft-big-img"
        />
        <div className="name xl">
            <div>Marine Mogul</div>
            <div className="id">#64</div>
        </div>
        <div className="rarity l">
            <div>Legendary</div>
            <div className="tide-turner">The Tide Turner</div>
        </div>
        <div className="traits">
            <div className="l">Traits</div>
            <li>Headware: <strong>Satellite Dish Hat</strong></li>
            <li>Eyewear: <strong>Monocle with a Dollar Sign</strong></li>
            <li>Neckwear: <strong>Rubber Chicken Tie</strong></li>
            <li>Attire: <strong>Suit of Armor</strong></li>
            <li>Item: <strong>Hourglass with Glitching Sand</strong></li>
            <li>Background: <strong>Sunken Bank Vault</strong></li>
            <li>Character: <strong>Humpback</strong></li>
        </div>
        <div className="craftable l">
            <div>Craftable: <span className="yes">YES</span></div>
            <div>Mergeable: <span className="yes">YES</span></div>
        </div>
    </div>
}
export default NftCardBig